define([
    "dojo/_base/declare",
    "dojo/aspect",
    "csi/xml",
    "SiteAdmin/SettingsTable"
], function(declare,aspect,xml,SettingsTable) {

    return declare(SettingsTable, {
        preAction: function(/*Controller*/ac) {
            // summary: hook to a controller to update Modified attribute on the node
            if (this.isConfigurable(ac)) {
                aspect.after(ac, "toWriter", function() {
                    ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("Modified", xml.ATTR_BOOLEAN, true);
                    ac.bRefreshNode = true;
                });
            }

            return this.inherited(arguments);
        }
    });
});